<footer class="footer footer-center bg-base-200 text-base-content p-10 mt-auto">
  <aside>
    <p class="font-bold">Audio Analyzer</p>
    <p>Copyright © {{ currentYear }} - All rights reserved</p>
  </aside>
  <nav>
    <div class="grid grid-flow-col gap-4">
      <a href="/" class="link link-hover">Home</a>
      <a href="/docs" class="link link-hover">Documentation</a>
      <a href="/pricing" class="link link-hover">Pricing</a>
      <a href="/disclaimer" class="link link-hover">Terms of Use</a>
    </div>
  </nav>
</footer>
